import PackageInterface from "../../Interfaces/PackageInterface";
import { Field, useFormikContext } from "formik";
import { formatMoney, getImageSizes, getSrcSet, sectionSettings, translations } from "../../Helpers/WindowHelpers";
import { updateUpsellPackages } from "../../Helpers/FormikUpdateFunctions";
import ConfiguratorValue from "../../Interfaces/ConfiguratorValue";
import parse from 'html-react-parser';
import Modal from "./ModalSection";
import UpsellPackageModalBodyDisplay from "../Displays/UpsellPackageModalBodyDisplay";

interface UpsellPackageInterface {
    upsellPackage: PackageInterface,
    step: number
}

const UpsellPackage = ({ upsellPackage, step }: UpsellPackageInterface) => {
    const context = useFormikContext<any>();
    const baseTotalSum = upsellPackage.variants.map((variant) => parseInt(variant.price)).reduce((sum, a) => sum + a, 0);
    const roundedTotalSum = upsellPackage.variants.map((variant) => parseInt(variant.price)).reduce((sum, a) => sum + Math.round(a / 100), 0);

    const updateUpsellPackage = () => {
        updateUpsellPackages(upsellPackage, finalTotal().toString(), context, step);
    }

    const finalTotal = () => {
        if (upsellPackage.discount_amount <= 0) return baseTotalSum;
        return upsellPackage.discount_type == "Percentage" ? (roundedTotalSum - (roundedTotalSum * (upsellPackage.discount_amount / 100))) * 100 : roundedTotalSum - upsellPackage.discount_amount;
    }

    const priceRender = () => {
        const price = finalTotal();
        if (price <= 0) return (<>{sectionSettings.label_free}</>);
        return (<>+{formatMoney(price.toString())}</>)
    }

    const compareAtPriceRender = () => baseTotalSum > finalTotal() ? (<span className="text--strike color--gray-muted">{formatMoney(baseTotalSum.toString())}</span>) : null;

    return (
        <div className={`card-product__link round d--flex upsell-package`}>
            {upsellPackage.image.src &&
                <div className="ratio ratio--4-3 width--100" aria-label={upsellPackage.image.alt}>
                    <img
                        className="d--block ratio__content ratio__content--cover"
                        srcSet={getSrcSet(upsellPackage.image.src, [200, 300, 400, 600, 800])}
                        sizes={getImageSizes('400px', [
                            {
                                screen: 576,
                                view: '200px'
                            },
                            {
                                screen: 1024,
                                view: '300px'
                            },
                            {
                                screen: 1730,
                                view: '400px'
                            }
                        ])}
                        //sizes="(max-width: 767px) 16vw,(min-width: 768px) and (max-width: 1730px) 8vw, 110px"
                        alt={upsellPackage.image.alt}
                        loading="lazy"
                        role="presentation"
                    />
                </div>
            }
            <div className="promo-cards__bottom">
                <label tabIndex={0} className="h5 d--flex gap-4 justify--space-between sm--justify-end sm--flex-row-reverse" htmlFor={`${upsellPackage.name}`}>
                    <div className="d--flex sm--flex-column gap-4 flex-wrap--wrap">
                        {upsellPackage.name}
                        {upsellPackage.bestseller ? (<span className="cover-configurator-bestseller">{translations.bestseller}</span>) : null}
                    </div>
                    <span className="custom-control custom-control--sm">
                        <Field
                            className={"promo-cards__input visually-hidden"}
                            name={"upgrade_and_accessory_package"}
                            value={upsellPackage.name}
                            type="checkbox"
                            checked={context.values?.variants?.some((item: ConfiguratorValue) => item.value == upsellPackage.name)}
                            id={upsellPackage.name}
                            onChange={updateUpsellPackage} />
                        <span className="custom-control__element"></span>
                    </span>
                </label>
                <div className="mt-20 card-product__desc">{parse(upsellPackage.description ?? '')}</div>
                <div className="d--flex justify--space-between align-items--end mt-20">
                    <p className="promo-cards__price mb-0">
                        <span className="d--block width--100 text--sm text--bold percent--off">
                            {upsellPackage.discount_amount}{upsellPackage.discount_type == "Percentage" ? `% ${sectionSettings.label_off}` : `${sectionSettings.label_off_each}`}
                        </span>
                        {priceRender()} {compareAtPriceRender()}
                    </p>
                    {upsellPackage.modal_description &&
                        <Modal
                            classes="link card-element"
                            buttonBody={translations.details}
                        >
                            <UpsellPackageModalBodyDisplay
                                upsellPackage={upsellPackage}
                                step={step}
                            />
                        </Modal>}
                </div>
            </div>
        </div>
    );
}

export default UpsellPackage;